@if (isWeb()) {
  <app-navbar />
  <app-sidebar />
}
<ion-app>
  <ion-router-outlet [class.web]="isWeb()" />
</ion-app>
<app-splash-loader />
